export var PostHogFeatureFlags;
(function (PostHogFeatureFlags) {
    PostHogFeatureFlags["Test"] = "test";
})(PostHogFeatureFlags || (PostHogFeatureFlags = {}));
